import { apiErrorMessage } from './prescriptionForm';

/**
 * Pure logic for the confirm-your-email screen (VerifyEmail.js).
 *
 * Named verifyForm, not verifyEmail, for the reason forgotForm and resetForm
 * are: on a case-insensitive filesystem verifyEmail.js and VerifyEmail.js are
 * the same file, and writing one silently replaces the other.
 *
 * The token is read with resetForm's tokenFromSearch, not a copy of it: the
 * confirmation token is a JWT, whose dots and base64url characters are exactly
 * what that function exists to carry through intact.
 */

/**
 * Map a failed confirmation to something the user can act on.
 *
 * A 400 is the one answer the server gives for unknown, expired, already used
 * and forged links (api-contract.md AUTH-7). The client has no more information
 * than that, so it offers the remedy that works for every one of them: a
 * password reset reaches the same inbox and confirms the address on the way
 * (AUTH-31). Resending the confirmation is deliberately not offered — see
 * notifyExistingAccount in routes/users.go for why that would be unsafe.
 */
export function verifyErrorMessage(error) {
  if (!error?.response) {
    return 'Could not reach the server. Check your connection and try again.';
  }
  if (error.response.status === 400) {
    return 'This link has expired or has already been used. If you cannot sign in, reset your password — that confirms your email too.';
  }
  if (error.response.status === 404) {
    return 'Email confirmation is not available on this server. Ask your coach for help getting started.';
  }
  return apiErrorMessage(error, 'Something went wrong confirming your email.');
}
